import { useMutation } from '@tanstack/react-query'

import { scenarioResultsClient } from '@/api'
import { downloadFromBlob } from '@/utils'

import { DownloadResultsSectionNames } from '../types'

export const useDownloadResults = (
  scenarioId: number,
  sections: DownloadResultsSectionNames[]
) => {
  const downloadFileMutation = useMutation({
    mutationFn: () =>
      scenarioResultsClient.downloadResultsFile(scenarioId, sections),
    onSuccess: result =>
      downloadFromBlob(`CalculationResults_${scenarioId}.zip`, result)
  })

  return {
    downloadFile: downloadFileMutation.mutate,
    isDownloading: downloadFileMutation.isPending
  }
}
